export function HeaderApp() {
  return {
    isMobileMenuOpen: false,
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },
    closeMobileMenu() {
      this.isMobileMenuOpen = false;
      window.theme.modals.menu.close();
    },
    setHeaderHeightCSSProperty() {
      const header = document.querySelector('header');
      const headerHeight = header.offsetHeight;
      this.offsetHeight = headerHeight;

      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
    },
    setHeaderInfoHeightCSSProperty() {
      const headerInfo = document.querySelector('.header-info');
      const headerInfoHeight = headerInfo.offsetHeight;

      document.documentElement.style.setProperty('--header-info-height', `${headerInfoHeight}px`);
    },
    mountHeader() {
      this.setHeaderHeightCSSProperty();
      this.setHeaderInfoHeightCSSProperty();
    },
    $delimiters: ['${', '}$'],
  };
}
